import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import { useState } from "react"
import PaymentReceivableList from "./PaymentReceivableList"

const PaymentReceivable = () => {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)
    return (
        <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
            <NavBar
                childrenPage={<PaymentReceivableList />}
                menuId={29}
            />
        </DataContext.Provider>
    )
}

export default PaymentReceivable